<template>
    <div>
        <!-- Section header -->
        <div class="dashboard-section-header mb-3 mt-5">
            <div class="d-flex align-items-center gap-2">
                <img :src="iconSharing" alt="" class="dashboard-section-header__icon">
                <span class="dashboard-section-header__title">{{ $t('cert.sharedCertificates') }}</span>
                <span class="count-badge ms-2">{{ sharedCerts.length }}</span>
            </div>
            <router-link :to="{ name: 'CertList', query: { filter: 'shared' } }" class="dashboard-show-all">
                {{ $t('cert.viewAllShared') }}
                <i class="bi bi-chevron-right dashboard-show-all__chevron"></i>
            </router-link>
        </div>

        <!-- Loading -->
        <Skeletor v-if="loading" />

        <!-- Empty state -->
        <div v-if="!loading && !sharedCerts.length" class="text-muted mb-5" style="font-size: 14px;">
            {{ $t('general.noRecord') }}
        </div>

        <!-- Cards -->
        <div v-if="!loading && sharedCerts.length" class="shared-certs-grid mb-5">
            <router-link
                class="shared-cert-card"
                v-for="cert in sharedCerts.slice(0, 4)"
                :key="cert.uuid"
                :to="{ name: 'CertDetail', params: { uuid: cert.uuid } }"
            >
                <!-- Top: blue bg + file icon -->
                <div class="shared-cert-card__top">
                    <img :src="iconFile" alt="" class="shared-cert-card__file-icon">
                </div>

                <!-- Bottom: cert info -->
                <div class="shared-cert-card__bottom">
                    <div class="shared-cert-card__row-meta">
                        <div class="d-flex align-items-center gap-2">
                            <span class="shared-cert-card__date">{{ formatDateShort(cert.created_at) }}</span>
                            <span
                                class="shared-cert-card__sharing-icon"
                                :style="{ maskImage: `url(${iconSharingChain})`, webkitMaskImage: `url(${iconSharingChain})` }"
                            ></span>
                        </div>
                        <span class="shared-cert-card__date">{{ formatTime(cert.created_at) }}</span>
                    </div>
                    <div class="shared-cert-card__name">{{ cert.name }}</div>
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
import http from '@/http';
import iconFile from '/public/img/new-design/icons/file.svg';
import iconSharing from '/public/img/new-design/icons/sharing.svg';
import iconSharingChain from '/public/img/new-design/icons/sharing.svg';

export default {
    mounted() {
        this.getCertsList();
    },

    data() {
        return {
            certsList: [],
            loading: true,
            iconFile,
            iconSharing,
            iconSharingChain,
        };
    },

    computed: {
        sharedCerts() {
            return this.certsList.filter(c =>
                ['link', 'logged'].includes(c.file?.sharing_settings?.mode)
            );
        },
    },

    methods: {
        getCertsList() {
            http.get('/certs/list').then((response) => {
                this.certsList = response.data.userCerts;
                this.loading = false;
            });
        },

        formatDateShort(dateStr) {
            const d = new Date(dateStr);
            const days = ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'];
            return `${days[d.getDay()]} ${d.getDate()}. ${d.getMonth() + 1}. ${d.getFullYear()}`;
        },

        formatTime(dateStr) {
            const d = new Date(dateStr);
            const pad = n => String(n).padStart(2, '0');
            return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
        },
    },
};
</script>